import { render, staticRenderFns } from "./SettingsSale.vue?vue&type=template&id=79b6f465"
import script from "./SettingsSale.vue?vue&type=script&lang=js"
export * from "./SettingsSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports